<template>
  <select class="form-control m-input" @select="emitChangeEvent" @change="emitChangeEvent">
    <option value="">{{ firstOption }}</option>
    <option
      v-for="reason in selects"
      :key="reason.id"
      :value="reason.id"
      :selected="reason.id == selected"
      >{{ reason.reason }}</option
    >
  </select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'SelectDiscountReasons',
  data() {
    return {
      selectedReasonId: '',
      firstOption: this.first ? this.first : 'Todos',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
  },
  methods: {
    getData() {
      const url = `${baseApiUrl}/v1/customer/discounts/reasons`;

      axios
        .get(url)
        .then((res) => {
          this.selects = res.data;
        })
        .catch((error) => {
          this.logMessageFormFailed(error.response);
        });
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
